import React from 'react';
import NavbarEight from '../components/NavbarEight';
import BannerNine from '../components/BannerNine';
import AboutAreaNine from '../components/AboutAreaNine';
import ServiceAreaEight from '../components/ServiceAreaEight';
import RoadmapOne from '../components/RoadmapOne';
import CounterAreaSix from '../components/CounterAreaSix';
import TestimonialEight from '../components/TestimonialEight';
import GalleryOne from '../components/GalleryOne';
import ProgressOne from '../components/ProgressOne';
import TeamAreaSix from '../components/TeamAreaSix';
import BlogAreaNine from '../components/BlogAreaNine';
import FooterEight from '../components/FooterEight';

const HomeNine = () => {
  return (
    <>
      {/* NavbarEight */}
      <NavbarEight />

      {/* BannerNine */}
      <BannerNine />

      {/* AboutAreaNine */}
      <AboutAreaNine />

      {/* ServiceAreaEight */}
      <ServiceAreaEight />

      {/* RoadmapOne */}
      <RoadmapOne />

      {/* ContactAreaSeven */}
      <CounterAreaSix />

      {/* TestimonialEight */}
      <TestimonialEight />

      {/* GalleryOne */}
      <GalleryOne />

      {/* ProgressOne */}
      <ProgressOne />

      {/* TeamAreaSix */}
      <TeamAreaSix />

      {/* BlogAreaNine */}
      <BlogAreaNine />

      {/* FooterEight */}
      <FooterEight />
    </>
  );
};

export default HomeNine;
